const initializedHeadings = new WeakSet();

export const initializeMobileHeaders = root => {
    root.querySelectorAll('main header h1').forEach(h1 => {
        if (initializedHeadings.has(h1)) {
            return;
        }

        initializedHeadings.add(h1);

        h1.addEventListener('click', () => h1.classList.toggle('opened'));
    });
};
